// generated from 14_962 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const cityFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("city_filter"),
  comparison_key: z.enum([
    "1", // 9_015 (60.25%)
    "26", // 2_625 (17.54%)
    "10", // 1_838 (12.28%)
    "25", // 578 (3.86%)
    "11", // 435 (2.91%)
    "2", // 369 (2.47%)
    "17", // 97 (0.65%)
    "12", // 5 (0.03%)
  ]),
  display_name: z.string(),
  // undefined: 7_372 (49.27%), defined 7_590 (50.73%)
  raw_value: z
    .union([
      // string samples: 4_515 (59.49%)
      z.string(),
      // array samples: 3_075 (40.51%)
      z.array(z.string()),
    ])
    .optional(),
  value: z.union([
    // string samples: 11_759 (78.59%)
    z.string(),
    // array samples: 3_203 (21.41%)
    z.array(z.string()),
  ]),
  varies_by_app_group: z.literal(false),
});
